import { render, staticRenderFns } from "@/manager/purchase/views/convocation-detail/purchase-row/purchase-participant-table/purchase-participant-table.pug?vue&type=template&id=28ecd634&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/manager/purchase/views/convocation-detail/purchase-row/purchase-participant-table/purchase-participant-table.scss?vue&type=style&index=0&id=28ecd634&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ecd634",
  null
  
)

export default component.exports